import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Wedding } from '../Weddings';
import { IWeddingCampaign } from './Campaigns.types';
import { CampaignMessages } from './Campaigns/Messages';

@Identifiable
@Timestampable
@Untrackable
export class Campaign extends AbstractDocument<IWeddingCampaign> {
  readonly collections = {
    Messages: new CampaignMessages(this),
  };

  /**
   * Returns the parent Wedding of this Campaign
   */
  get wedding() {
    return this.reference.parent.parent!.id;
  }
}

export class Campaigns extends AbstractCollection<Campaign, IWeddingCampaign> {
  static path = 'campaigns';

  constructor(document: Wedding) {
    super(document.collection(Campaigns.path), Campaign);
  }
  /**
   * Returns the parent Wedding of this Campaigns collection
   */
  get wedding() {
    return this.reference.parent!.id;
  }
}
